import { UserLightResponse } from "../types/user";
import styles from "./Avatar.module.css";

interface AvatarProps {
  user: UserLightResponse;
  pictureUrl: string | null | undefined;
}

export function Avatar({ user, pictureUrl }: AvatarProps) {
  function getUserName(user: UserLightResponse) {
    return `${user.firstName} ${user.lastName}`;
  }

  function getAvatarText(user: UserLightResponse) {
    const name = getUserName(user);
    const parts = name.trim().split(/\s+/).filter(Boolean);
    const first = parts[0] ?? "";
    const last = parts[parts.length - 1] ?? "";
    if (parts.length >= 2) {
      return ((first[0] ?? "") + (last[0] ?? "")).toUpperCase();
    }
    return first.substring(0, 2).toUpperCase();
  }

  if (pictureUrl) {
    return <img className={styles.avatarImg} src={pictureUrl} alt={getUserName(user)} />;
  }
  return <div className={styles.avatar}>{getAvatarText(user)}</div>;
}
